export const SHOW_ERROR_DIALOG = 'errorDialog:SHOW_ERROR_DIALOG';
export const DISMISS_ERROR_DIALOG = 'errorDialog:DISMISS_ERROR_DIALOG';
